var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.formModel &&
    _vm.formModel.requestId !== undefined &&
    _vm.formModel.requestId !== "" &&
    (!_vm.formModel.docId || _vm.formModel.docId === "") &&
    _vm.formModel.isLoadingCard === true
    ? _c(
        "div",
        {
          key: _vm.formModel && _vm.formModel.requestId,
          staticClass: "go-card-body",
          staticStyle: {
            "justify-content": "center",
            "align-items": "center",
            height: "100%",
          },
        },
        [
          !_vm.isShowReloading
            ? _c(
                "div",
                {
                  staticClass: "go-loading2",
                  staticStyle: {
                    "justify-content": "center",
                    "align-items": "center",
                    height: "100%",
                  },
                },
                [
                  _c("div", { staticClass: "go-progress" }, [
                    _c("div", {
                      staticClass: "go-progress-bar go-shimmer",
                      style: { width: this.loadingProcessNumber + "%" },
                      attrs: {
                        role: "progressbar",
                        "aria-valuenow": this.loadingProcessNumber,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "go-help-text" }, [
                    _vm._v("\n      " + _vm._s(_vm.generatedFirstText)),
                    _c("br"),
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t(
                            "briefing.loadingCardAndWidget.reportCardNoBriefing.loadingMessage.secondText"
                          )
                        ) +
                        "\n    "
                    ),
                  ]),
                ]
              )
            : _c("div", { staticClass: "go-empty" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("p", { staticClass: "go-help-text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "briefing.loadingCardAndWidget.reportCardNoBriefing.reLoadingMessage.firstText"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-btn-area" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default go-btn-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleReloadingReportCard.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "go-icon-16 go-icon-reload" }),
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "briefing.loadingCardAndWidget.reportCardNoBriefing.reLoadingMessage.buttonText"
                          )
                        ) + "\n      "
                      ),
                    ]
                  ),
                ]),
              ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-icon-wrap" }, [
      _c("i", { staticClass: "go-icon-40 go-icon-alert-circleE" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }